import { BTN_TXT } from 'constants/txt'
import { Button, BUTTON_TYPES } from 'components/Button'
import { useContractDetailsPopup } from 'features/ContractDetails/Providers/ContractDetailsPopupProvider'
import { useContractDetailsContext } from 'features/ContractDetails/Providers/ContractDetailsContextProvider'
import {
  ACTIONS,
  contractSubject,
  SUBJECTS
} from 'features/ContractDetails/Abilities'
import { Can } from 'features/ContractDetails/Providers/ContractDetailsAbilityProvider'
import { CONTRACT_STATUS } from '../../constants'

export default () => {
  const contractDetailsContext = useContractDetailsContext()
  const { terminateContractPopup, terminateContractWithDatePopup } =
    useContractDetailsPopup()

  const { details } = contractDetailsContext.state

  const handleTerminateModal = () => {
    if (details.status === CONTRACT_STATUS.ACTIVE) {
      terminateContractWithDatePopup.actions.open()
    } else terminateContractPopup.actions.open()
  }

  return (
    <Can I={ACTIONS.CANCEL} a={contractSubject(SUBJECTS.CONTRACT, details)}>
      {!details.termination_date ? (
        <Button
          type={BUTTON_TYPES.DEFAULT}
          onClick={handleTerminateModal}
          danger
          upperCase
        >
          {BTN_TXT.TERMINATE}
        </Button>
      ) : (
        <span />
      )}
    </Can>
  )
}
